import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:215c95fd-3612-4e1e-9971-a2e0aafdcf23",
    aws_user_pools_id: "ap-southeast-2_GK6V3CXLh",
    aws_user_pools_web_client_id: "63ncdarcfer1j2d9apv9gq2v68",
    Auth: {
      identityPoolId: "ap-southeast-2:215c95fd-3612-4e1e-9971-a2e0aafdcf23",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_GK6V3CXLh",
      userPoolWebClientId: "63ncdarcfer1j2d9apv9gq2v68",
    },
    oauth: {
      domain: `whs-safer-beta-sg.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://beta.sg.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.sg.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
